import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// create a slice for pipeline refresh
interface PipelineRefreshState {
    refresh: boolean;
}

const initialState: PipelineRefreshState = {
    refresh: false,
};

const pipelineRefreshSlice = createSlice({
    name: 'pipelineRefresh',
    initialState,
    reducers: {
        setPipelineRefresh: (state, action: PayloadAction<boolean>) => {
            state.refresh = action.payload;
        },
        resetPipelineRefresh: () => initialState,
    },
});

export const { setPipelineRefresh, resetPipelineRefresh } = pipelineRefreshSlice.actions;
export default pipelineRefreshSlice.reducer;